import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'; // Asumiendo que usarás el mismo o crearás uno para SuperAdmin
import { Building2, PlusCircle, Edit, ShieldBan, ShieldCheck, CheckCircle2, Search, X, Activity } from 'lucide-react';

const PanelSuperAdmin = () => {

  const navigate = useNavigate();
  const [instituciones, setInstituciones] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [terminoBusqueda, setTerminoBusqueda] = useState('');

  // Estados para el Modal de Crear/Editar
  const [mostrarModal, setMostrarModal] = useState(false);

  const [formData, setFormData] = useState({
    nombre: '', 
    ruc: '', 
    dominio: '', 
    telefono: '',
    // Nuevos campos del Director:
    nombresDirector: '',
    apellidosDirector: '',
    dniDirector: '',
    correoDirector: ''
  });

  const [editandoId, setEditandoId] = useState(null); // Guardará el ID del colegio a editar

    const [modalSmtpAbierto, setModalSmtpAbierto] = useState(false);
    const [cargandoSmtp, setCargandoSmtp] = useState(false);
    const [smtpData, setSmtpData] = useState({
    servidor: '', puerto: 587, correo: '', password: '', usaSSL: true
    });

    // Estados para el Escudo de Administradores
  const [modalAdminsAbierto, setModalAdminsAbierto] = useState(false);
  const [adminsColegio, setAdminsColegio] = useState([]);
  const [colegioSeleccionado, setColegioSeleccionado] = useState(null);
  const [cargandoAdmins, setCargandoAdmins] = useState(false);


  // --- EL MOTOR DE ARRANQUE Y SEGURIDAD ---
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    try {
      // Leemos el Token para saber si es el SuperAdmin
      const payloadBase64 = token.split('.')[1].replace(/-/g, '+').replace(/_/g, '/');
      const decodedPayload = JSON.parse(window.atob(payloadBase64));
      const userRole = decodedPayload["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] || decodedPayload.role;
      
      if (userRole !== 'SuperAdmin') {
        alert("Acceso denegado: Área exclusiva de EMD Ingeniería.");
        navigate('/dashboard'); 
        return; 
      }
    } catch (error) {
      localStorage.removeItem('token');
      navigate('/login');
      return;
    }

    // Llamamos a la función que trae los datos
    cargarInstituciones();
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

// Al usar "async function" en lugar de "const = async () =>", 
  // JavaScript la hace visible para TODO el archivo al instante.
  async function cargarInstituciones() {
    setCargando(true);
    const token = localStorage.getItem('token');
    if (!token) return navigate('/login');
    
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Instituciones`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (res.ok) {
        setInstituciones(await res.json());
      } else if (res.status === 403) {
        alert("Acceso denegado. No tienes permisos de SuperAdmin.");
        navigate('/dashboard'); 
      }
    } catch (e) {
      console.error("Error al cargar instituciones", e);
    } finally {
      setCargando(false);
    }
  }



  // Filtrado en tiempo real
  const institucionesFiltradas = instituciones.filter(inst => {
    if (!terminoBusqueda) return true;
    const busquedaMinuscula = terminoBusqueda.toLowerCase();
    const nombre = (inst.nombre || inst.Nombre || '').toLowerCase();
    const ruc = (inst.ruc || inst.RUC || '').toLowerCase();
    return nombre.includes(busquedaMinuscula) || ruc.includes(busquedaMinuscula);
  });

  const abrirModalNuevo = () => {
    setEditandoId(null);
    setFormData({ nombre: '', ruc: '', dominio: '', telefono: '' });
    setMostrarModal(true);
  };

  const cerrarModal = () => {
    setMostrarModal(false);
  };


const abrirGestionAdmins = async (institucion) => {
    // 1. Aseguramos el ID correcto
    const idColegio = institucion.id || institucion.Id;
    
    setColegioSeleccionado(institucion);
    setModalAdminsAbierto(true);
    setCargandoAdmins(true);
    const token = localStorage.getItem('token');
    
    try {
      console.log(`Buscando admins para el colegio ID: ${idColegio}`); // Rastreador 1
      
      const res = await fetch(`${process.env.REACT_APP_API_URL}/Instituciones/${idColegio}/Administradores`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });
      
      if (res.ok) {
        setAdminsColegio(await res.json());
      } else {
        // Rastreador 2: Capturamos el mensaje exacto del servidor
        const errorText = await res.text();
        console.error(`Error del servidor (${res.status}):`, errorText);
        alert(`Fallo de conexión. Código: ${res.status}. Revisa la consola (F12) para más detalles.`);
      }
    } catch (error) {
      console.error("Error de red puro:", error);
      alert("Error de red al intentar conectar con el servidor.");
    } finally {
      setCargandoAdmins(false);
    }
};




  const abrirConfiguracionSmtp = async () => {
  setModalSmtpAbierto(true);
  const token = localStorage.getItem('token');
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/ConfiguracionSmtp`, {
      headers: { 'Authorization': `Bearer ${token}` }
    });
    if (res.ok) {
      const data = await res.json();
      setSmtpData(data); // Si ya hay datos en la BD, los mostramos
    }
  } catch (error) { console.error("Error cargando SMTP", error); }
};

const handleGuardarSmtp = async (e) => {
  e.preventDefault();
  setCargandoSmtp(true);
  const token = localStorage.getItem('token');
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/ConfiguracionSmtp`, {
      method: 'POST',
      headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify(smtpData)
    });
    if (res.ok) {
      alert("¡Configuración SMTP guardada! El sistema ya puede enviar correos.");
      setModalSmtpAbierto(false);
    } else {
      alert("Error al guardar la configuración SMTP.");
    }
  } catch (error) { alert("Error de conexión"); } finally { setCargandoSmtp(false); }
};


const handleGuardar = async (e) => {
    e.preventDefault();
    setCargando(true);
    const token = localStorage.getItem('token');
    
    // Este payload ahora coincide EXACTAMENTE con tu RegistroColegioDto de C#
    const payload = {
      nombre: formData.nombre,
      ruc: formData.ruc,
      dominio: formData.dominio,
      telefono: formData.telefono,
      nombresDirector: formData.nombresDirector,
      apellidosDirector: formData.apellidosDirector,
      dniDirector: formData.dniDirector,
      correoDirector: formData.correoDirector
    };

try {
      let res;
      if (editandoId) {
        // MODO EDICIÓN (PUT): Solo enviamos los datos del colegio
        res = await fetch(`${process.env.REACT_APP_API_URL}/Instituciones/${editandoId}`, {
          method: 'PUT',
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: editandoId, nombre: formData.nombre, ruc: formData.ruc, 
            dominio: formData.dominio, telefono: formData.telefono, activo: true
          })
        });
      } else {
        // MODO CREACIÓN B2B (POST): Enviamos todo al Onboarding
        res = await fetch(`${process.env.REACT_APP_API_URL}/Instituciones/Onboarding`, {
          method: 'POST',
          headers: { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
          body: JSON.stringify(payload)
        });
      }

      if (res.ok) {
        setFormData({ nombre: '', ruc: '', dominio: '', telefono: '', nombresDirector: '', apellidosDirector: '', dniDirector: '', correoDirector: '' }); 
        setEditandoId(null);
        cerrarModal(); 
        cargarInstituciones(); 
        alert(editandoId ? "Colegio actualizado correctamente." : "¡Colegio y Director creados con éxito!");
      } else {
        alert("Error al procesar la solicitud.");
      }
    } catch (error) {
      console.error("Error de conexión:", error);
      alert("Error de conexión con el servidor.");
    } finally {
      setCargando(false);
    }
  };


  const handleEliminar = async (id, nombre) => {
  if (!window.confirm(`⚠️ ¿Estás absolutamente seguro de eliminar el colegio "${nombre}"?\nEsta acción es irreversible.`)) return;

  const token = localStorage.getItem('token');
  try {
    const res = await fetch(`${process.env.REACT_APP_API_URL}/Instituciones/${id}`, {
      method: 'DELETE',
      headers: { 'Authorization': `Bearer ${token}` }
    });

    if (res.ok) {
      alert("Colegio eliminado correctamente.");
      cargarInstituciones(); // Recarga la tabla
    } else {
      alert("Hubo un error al intentar eliminar el colegio.");
    }
  } catch (error) {
    console.error("Error:", error);
    alert("Error de conexión.");
  }
};

const handleEditar = (institucion) => {
  // Llenamos el formulario con los datos del colegio seleccionado
  setFormData({
    nombre: institucion.nombre,
    ruc: institucion.ruc,
    dominio: institucion.dominio,
    telefono: institucion.telefono || '',
    // Dejamos los del director vacíos porque no los editaremos aquí
    nombresDirector: '', apellidosDirector: '', dniDirector: '', correoDirector: ''
  });
  setEditandoId(institucion.id); // Guardamos el ID
  setMostrarModal(true); // Abrimos la ventana
};


  return (

    <div className="min-h-screen bg-slate-50 flex">
      <Sidebar />
      <main className="flex-1 p-6 lg:p-10 overflow-y-auto">
        
        {/* ENCABEZADO */}
        <header className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
          <div>
            <h1 className="text-3xl font-bold text-slate-800 flex items-center gap-3">
              <Building2 className="text-indigo-600" size={32} /> 
              Suscripciones B2B
            </h1>
            <p className="text-slate-500 mt-2 text-sm">
              Centro de comando global. Gestiona todos los colegios de EduControl.
            </p>
          </div>
          
          <button 
            onClick={abrirModalNuevo}
            className="bg-indigo-600 text-white px-5 py-2.5 rounded-lg font-bold hover:bg-indigo-700 flex items-center gap-2 transition-all shadow-sm hover:shadow-md"
          >
            <PlusCircle size={20} /> Registrar Colegio
          </button>
          
            <button onClick={abrirConfiguracionSmtp} className="bg-slate-800 text-white px-4 py-2 rounded-lg font-bold flex items-center gap-2 hover:bg-slate-900 transition-colors shadow-sm">
            {/* Usa un icono de tuerca o correo de Lucide aquí */}
            Configurar Correo (SMTP)
            </button>

        </header>

        {/* TARJETAS DE MÉTRICAS */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4 border-l-4 border-l-indigo-500">
            <div className="p-3 bg-indigo-50 rounded-lg text-indigo-600"><Building2 size={24}/></div>
            <div>
              <p className="text-sm font-bold text-slate-500">Total Colegios</p>
              <p className="text-2xl font-black text-slate-800">{instituciones.length}</p>
            </div>
          </div>
          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4 border-l-4 border-l-green-500">
            <div className="p-3 bg-green-50 rounded-lg text-green-600"><CheckCircle2 size={24}/></div>
            <div>
              <p className="text-sm font-bold text-slate-500">Activos</p>
              <p className="text-2xl font-black text-slate-800">{instituciones.filter(i => i.activo || i.Activo).length}</p>
            </div>
          </div>
          <div className="bg-white p-5 rounded-xl border border-slate-200 shadow-sm flex items-center gap-4 border-l-4 border-l-amber-500">
            <div className="p-3 bg-amber-50 rounded-lg text-amber-600"><Activity size={24}/></div>
            <div>
              <p className="text-sm font-bold text-slate-500">En Soporte</p>
              <p className="text-2xl font-black text-slate-800">{instituciones.filter(i => i.permitirSoporteEMD || i.PermitirSoporteEMD).length}</p>
            </div>
          </div>
        </div>

        {/* CONTENEDOR PRINCIPAL */}
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden flex flex-col">
          
          {/* BARRA DE BÚSQUEDA */}
          <div className="p-4 border-b bg-slate-50/50">
            <div className="flex items-center border rounded-lg bg-white overflow-hidden focus-within:ring-2 focus-within:ring-indigo-500 md:w-1/2">
              <div className="pl-3 text-slate-400"><Search size={18} /></div>
              <input 
                type="text" 
                value={terminoBusqueda}
                onChange={(e) => setTerminoBusqueda(e.target.value)}
                placeholder="Buscar por RUC o Nombre del Colegio..." 
                className="w-full p-2.5 outline-none text-sm"
              />
              {terminoBusqueda && (
                <button onClick={() => setTerminoBusqueda('')} className="pr-3 text-slate-400 hover:text-red-500">
                  <X size={16} />
                </button>
              )}
            </div>
          </div>

          {/* TABLA DE INSTITUCIONES */}
          <div className="overflow-x-auto">
            <table className="w-full text-left border-collapse whitespace-nowrap">
              <thead className="bg-slate-50 border-b">
                <tr className="text-xs text-slate-500 uppercase tracking-wider">
                  <th className="p-4 font-bold">ID</th>
                  <th className="p-4 font-bold">Institución</th>
                  <th className="p-4 font-bold">RUC</th>
                  <th className="p-4 font-bold text-center">Estado</th>
                  <th className="p-4 font-bold text-center">Soporte EMD</th>
                  <th className="p-4 font-bold text-center">Acciones</th>
                </tr>
              </thead>
              <tbody className="text-sm">
                {cargando ? (
                  <tr><td colSpan="6" className="p-8 text-center text-slate-500">Cargando datos desde el servidor...</td></tr>
                ) : institucionesFiltradas.length === 0 ? (
                  <tr><td colSpan="6" className="p-8 text-center text-slate-500 font-medium">No se encontraron colegios.</td></tr>
                ) : (
                  institucionesFiltradas.map(inst => (
                    <tr key={inst.id || inst.Id} className="border-b hover:bg-slate-50/80 transition-colors">
                      <td className="p-4 font-medium text-slate-400">#{inst.id || inst.Id}</td>
                      <td className="p-4">
                        <p className="font-bold text-slate-800">{inst.nombre || inst.Nombre}</p>
                        <p className="text-xs text-slate-500">{inst.dominio || inst.Dominio || 'Sin dominio'}</p>
                      </td>
                      <td className="p-4 font-medium text-slate-600">{inst.ruc || inst.RUC || 'N/A'}</td>
                      
                      {/* ESTADO DE SUSCRIPCIÓN */}
                      <td className="p-4 text-center">
                        {(inst.activo || inst.Activo) ? (
                          <span className="inline-flex items-center gap-1 bg-green-50 text-green-700 px-2.5 py-1 rounded-full text-xs font-bold border border-green-200">
                            <CheckCircle2 size={12}/> Activo
                          </span>
                        ) : (
                          <span className="inline-flex items-center gap-1 bg-red-50 text-red-700 px-2.5 py-1 rounded-full text-xs font-bold border border-red-200">
                            <ShieldBan size={12}/> Suspendido
                          </span>
                        )}
                      </td>

                      {/* ESTADO DE SOPORTE TÉCNICO */}
                      <td className="p-4 text-center">
                        {(inst.permitirSoporteEMD || inst.PermitirSoporteEMD) ? (
                          <span className="text-amber-600 font-bold text-xs bg-amber-50 px-2 py-1 rounded border border-amber-200" title="El colegio te dio permiso para entrar">
                            Habilitado
                          </span>
                        ) : (
                          <span className="text-slate-400 text-xs">Bloqueado</span>
                        )}
                      </td>

                      {/* BOTONES DE ACCIÓN */}
                      
                        <td className="p-4 border-b text-right">
                          <div className="flex justify-end gap-2">
                            {/* 1. Botón Soporte (Escudo) */}
                            <button 
                              onClick={() => abrirGestionAdmins(inst)} 
                              className="px-3 py-1.5 text-xs font-bold text-purple-600 bg-purple-50 hover:bg-purple-100 rounded-lg transition-colors flex items-center gap-1"
                              title="Gestionar Administradores"
                            >
                              🛡️ Soporte
                            </button>

                            {/* 2. Botón Editar */}
                            <button 
                              onClick={() => handleEditar(inst)} 
                              className="px-3 py-1.5 text-xs font-bold text-blue-600 bg-blue-50 hover:bg-blue-100 rounded-lg transition-colors"
                            >
                              Editar
                            </button>
                            
                            {/* 3. Botón Eliminar */}
                            <button 
                              onClick={() => handleEliminar(inst.id, inst.nombre)} 
                              className="px-3 py-1.5 text-xs font-bold text-red-600 bg-red-50 hover:bg-red-100 rounded-lg transition-colors"
                            >
                              Eliminar
                            </button>
                          </div>
                      </td>



                      
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
        </div>
      </main>



      {/* MODAL PARA CREAR INSTITUCIÓN (Versión simplificada) */}

            
{mostrarModal && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
    {/* Contenedor principal de la ventana */}
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] flex flex-col overflow-hidden">
      
      {/* Cabecera de la ventana (Fija) */}
      <div className="p-5 border-b border-slate-100 flex justify-between items-center bg-slate-50">
        <h2 className="text-xl font-bold text-slate-800">Registrar Nueva Institución</h2>
        <button onClick={cerrarModal} className="text-slate-400 hover:text-red-500 transition-colors">
          {/* Si tienes importado X de lucide-react, úsalo aquí. Si no, usa una "x" de texto */}
          <span className="text-xl font-bold">&times;</span> 
        </button>
      </div>

      {/* Cuerpo de la ventana (Con scroll interno y padding) */}
      <div className="p-6 overflow-y-auto">
        
        {/* === AQUÍ PEGAS TU ETIQUETA <form> EXACTAMENTE COMO ME LA ENVIASTE === */}
        <form onSubmit={handleGuardar} className="space-y-6">
             {/* SECCIÓN 1: DATOS DEL COLEGIO */}
  <div>
    <h3 className="text-sm font-bold text-blue-600 border-b pb-2 mb-3 uppercase tracking-wider">
      1. Datos de la Institución
    </h3>
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Nombre del Colegio *</label>
        <input type="text" required value={formData.nombre} onChange={e => setFormData({...formData, nombre: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="Ej: San Juan Bautista" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">RUC *</label>
        <input type="text" required value={formData.ruc} onChange={e => setFormData({...formData, ruc: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="Ej: 20123456789" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Dominio (URL) *</label>
        <input type="text" required value={formData.dominio} onChange={e => setFormData({...formData, dominio: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="Ej: edu.colegio.com" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Teléfono</label>
        <input type="text" value={formData.telefono} onChange={e => setFormData({...formData, telefono: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-blue-500 text-sm" placeholder="Ej: 999888777" />
      </div>
    </div>
  </div>

  {/* SECCIÓN 2: DATOS DEL DIRECTOR (ADMINISTRADOR) */}
  <div>
    <h3 className="text-sm font-bold text-emerald-600 border-b pb-2 mb-3 uppercase tracking-wider">
      2. Cuenta del Director (Administrador)
    </h3>
    <p className="text-xs text-slate-500 mb-3">Se generará una contraseña temporal y se enviará a este correo.</p>
    
    <div className="grid grid-cols-2 gap-4">
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Nombres *</label>
        <input type="text" required value={formData.nombresDirector} onChange={e => setFormData({...formData, nombresDirector: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-emerald-500 text-sm" placeholder="Ej: Carlos" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Apellidos *</label>
        <input type="text" required value={formData.apellidosDirector} onChange={e => setFormData({...formData, apellidosDirector: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-emerald-500 text-sm" placeholder="Ej: Pérez" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Documento Identidad (DNI) *</label>
        <input type="text" required value={formData.dniDirector} onChange={e => setFormData({...formData, dniDirector: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-emerald-500 text-sm" placeholder="Ej: 70123456" />
      </div>
      <div>
        <label className="block text-xs font-bold text-slate-500 mb-1">Correo Electrónico *</label>
        <input type="email" required value={formData.correoDirector} onChange={e => setFormData({...formData, correoDirector: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 outline-none focus:ring-2 focus:ring-emerald-500 text-sm" placeholder="director@colegio.com" />
      </div>
    </div>
  </div>

  {/* BOTONES */}
  <div className="flex justify-end gap-3 mt-6 pt-4 border-t">
    <button type="button" onClick={cerrarModal} className="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
      Cancelar
    </button>
    <button type="submit" disabled={cargando} className="px-6 py-2 text-sm font-bold text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-md transition-colors disabled:bg-blue-300 flex items-center gap-2">
      {cargando ? 'Registrando y Enviando...' : 'Crear Colegio y Notificar'}
    </button>
  </div>

        </form>

      </div>
    </div>
  </div>
)}



{modalSmtpAbierto && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-md overflow-hidden">
      <div className="p-5 border-b flex justify-between items-center bg-slate-50">
        <h2 className="text-lg font-bold text-slate-800">⚙️ Configuración SMTP Maestro</h2>
        <button onClick={() => setModalSmtpAbierto(false)} className="text-xl text-slate-400 hover:text-red-500 font-bold">&times;</button>
      </div>
      <div className="p-6">
        <p className="text-xs text-slate-500 mb-4">Credenciales del correo desde donde se enviarán todas las notificaciones de la plataforma.</p>
        <form onSubmit={handleGuardarSmtp} className="space-y-4">
          <div>
            <label className="block text-xs font-bold text-slate-500 mb-1">Servidor SMTP</label>
            <input type="text" required value={smtpData.servidor} onChange={e => setSmtpData({...smtpData, servidor: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 text-sm" placeholder="Ej: mail.emdingenieria.com o smtp.gmail.com" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div>
              <label className="block text-xs font-bold text-slate-500 mb-1">Puerto</label>
              <input type="number" required value={smtpData.puerto} onChange={e => setSmtpData({...smtpData, puerto: parseInt(e.target.value)})} className="w-full p-2 border rounded-lg bg-slate-50 text-sm" placeholder="Ej: 465 o 587" />
            </div>
            <div className="flex items-end pb-2">
              <label className="flex items-center gap-2 cursor-pointer">
                <input type="checkbox" checked={smtpData.usaSSL} onChange={e => setSmtpData({...smtpData, usaSSL: e.target.checked})} className="w-4 h-4 text-blue-600 rounded" />
                <span className="text-sm font-bold text-slate-700">Usar SSL/TLS</span>
              </label>
            </div>
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 mb-1">Correo Remitente</label>
            <input type="email" required value={smtpData.correo} onChange={e => setSmtpData({...smtpData, correo: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 text-sm" placeholder="soporte@tuempresa.com" />
          </div>
          <div>
            <label className="block text-xs font-bold text-slate-500 mb-1">Contraseña (o App Password)</label>
            <input type="password" required value={smtpData.password} onChange={e => setSmtpData({...smtpData, password: e.target.value})} className="w-full p-2 border rounded-lg bg-slate-50 text-sm" placeholder="••••••••" />
          </div>
          <div className="flex justify-end gap-3 mt-6 border-t pt-4">
            <button type="button" onClick={() => setModalSmtpAbierto(false)} className="px-4 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg">Cancelar</button>
            <button type="submit" disabled={cargandoSmtp} className="px-6 py-2 text-sm font-bold text-white bg-slate-800 hover:bg-slate-900 rounded-lg shadow-md disabled:bg-slate-400">
              {cargandoSmtp ? 'Guardando...' : 'Guardar SMTP'}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
)}


{/* MODAL: GESTIONAR ADMINISTRADORES (ESCUDO) */}
{modalAdminsAbierto && colegioSeleccionado && (
  <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-900/60 backdrop-blur-sm p-4">
    <div className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl max-h-[90vh] flex flex-col overflow-hidden">
      
      {/* Cabecera */}
      <div className="p-5 border-b border-slate-100 flex justify-between items-center bg-slate-50">
        <div>
          <h2 className="text-xl font-bold text-slate-800 flex items-center gap-2">
            🛡️ Administradores B2B
          </h2>
          <p className="text-xs text-slate-500 mt-1">
            Gestionando accesos para: <strong className="text-blue-600">{colegioSeleccionado.nombre}</strong>
          </p>
        </div>
        <button onClick={() => setModalAdminsAbierto(false)} className="text-2xl font-bold text-slate-400 hover:text-red-500 transition-colors">&times;</button>
      </div>

      {/* Cuerpo */}
      <div className="p-6 overflow-y-auto bg-slate-50/50 flex-1">
        {cargandoAdmins ? (
          <div className="text-center py-10 text-slate-500 font-bold">Cargando directores...</div>
        ) : adminsColegio.length === 0 ? (
          <div className="text-center py-10 text-slate-500 bg-white border border-dashed rounded-xl">
            No se encontraron cuentas de Administrador para este colegio.
          </div>
        ) : (
          <div className="bg-white border rounded-xl shadow-sm overflow-hidden">
            <table className="w-full text-left text-sm">
              <thead className="bg-slate-100 border-b text-slate-600">
                <tr>
                  <th className="p-3 font-bold">Director (Nombre Completo)</th>
                  <th className="p-3 font-bold">DNI / Doc.</th>
                  <th className="p-3 font-bold">Correo (Usuario)</th>
                  <th className="p-3 font-bold text-center">Estado</th>
                  <th className="p-3 font-bold text-center">Acciones Soporte</th>
                </tr>
              </thead>
              <tbody className="divide-y">
                {adminsColegio.map(admin => (
                  <tr key={admin.id} className="hover:bg-slate-50">
                    <td className="p-3 font-medium text-slate-800">{admin.apellidos}, {admin.nombres}</td>
                    <td className="p-3 text-slate-600">{admin.documentoIdentidad || admin.dni || 'N/A'}</td>
                    <td className="p-3 text-slate-600">{admin.email}</td>
                    <td className="p-3 text-center">
                      <span className={`px-2 py-1 rounded text-xs font-bold ${admin.activo ? 'bg-emerald-100 text-emerald-700' : 'bg-red-100 text-red-700'}`}>
                        {admin.activo ? 'Activo' : 'Bloqueado'}
                      </span>
                    </td>
                    <td className="p-3 text-center">
                      <button 
                        onClick={() => alert(`Función para enviar nueva clave temporal al correo ${admin.email} en construcción.`)}
                        className="px-3 py-1.5 text-xs font-bold text-amber-700 bg-amber-100 hover:bg-amber-200 rounded-lg transition-colors"
                      >
                        Resetear Clave
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Pie de ventana */}
      <div className="p-4 border-t bg-white flex justify-end">
        <button onClick={() => setModalAdminsAbierto(false)} className="px-5 py-2 text-sm font-bold text-slate-600 hover:bg-slate-100 rounded-lg transition-colors">
          Cerrar Panel
        </button>
      </div>

    </div>
  </div>
)}





    </div>
  );
};

export default PanelSuperAdmin;